import * as React from "react";
import "./modal.scss";

interface IModalProps {
  img?: string;
  title: string;
  text: string;
  noActions?: boolean;
  confirmFn: () => void;
  cancelFn: () => void;
  buttons?: {
    confirm?: string;
    cancel?: string;
  };
}

const Modal: React.FC<IModalProps> = (props) => {
  const {
    img,
    title,
    text,
    confirmFn,
    cancelFn,
    buttons,
    noActions,
  } = props;

  return (
    <div className="app-modal">
      <div className="app-modal__content">
        {img && <img src={img} style={{ padding: "5px" }} alt="" />}
        {title && <h3>{title}</h3>}
        {text && <p dangerouslySetInnerHTML={{ __html: text }} />}
      </div>
      {!noActions && (
        <div className="app-modal__action">
          {buttons && buttons.cancel && (
            <button className="white" onClick={cancelFn}>
              {buttons.cancel}
            </button>
          )}

          <button onClick={confirmFn}>
            {(buttons && buttons.confirm) || "OK"}
          </button>
        </div>
      )}
    </div>
  );
};

export default Modal;
